import React, { FC } from 'react';
import { ParagraphMultiSegment } from '../../store/guide';

interface MultiSegmentParagraphProps {
  segments: ParagraphMultiSegment;
  onLinkClick: (targetId: string) => void;
}

const MultiSegmentParagraph: FC<MultiSegmentParagraphProps> = ({
  segments,
  onLinkClick,
}) => {
  return (
    <div className="mt-2">
      {segments.map((segment) => {
        if (segment.type === 'link') {
          return (
            <button
              type="button"
              onClick={() => {
                onLinkClick(segment.linkTo);
              }}
              key={segment.text}
              className="text-sm font-bold leading-6 underline"
            >
              {segment.text}
            </button>
          );
        }
        return (
          <span className="text-sm leading-6" key={segment.text}>
            {segment.text}
          </span>
        );
      })}
    </div>
  );
};

export default MultiSegmentParagraph;
